import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dropdown } from '@carbon/react';
import { SettingsNavItem, SettingsNavSection } from 'src/config/settingsNav';

interface StorefrontNavDropdownProps {
  sections: SettingsNavSection[];
}

const StorefrontNavDropdown = React.memo(({ sections }: StorefrontNavDropdownProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = useMemo(
    () =>
      sections.flatMap((section) =>
        section.items.map((item) => ({
          ...item,
          // Always qualify with the section, matching the sidebar. Collapsing a
          // single-item section to its section name alone hid the item's own label.
          label: `${t(section.labelKey)} › ${t(item.labelKey)}`,
        }))
      ),
    [sections, t]
  );

  const selected = items.find((item) => item.path === pathname) || items[0];

  return (
    <Dropdown
      id={'storefront-nav-dropdown'}
      className={'storefront-nav-dropdown'}
      titleText={t('storefrontNav.title')}
      hideLabel
      label={t('storefrontNav.title')}
      items={items}
      selectedItem={selected}
      itemToString={(item) => (item as { label: string })?.label || ''}
      onChange={({ selectedItem }) => {
        const next = selectedItem as SettingsNavItem | null;
        if (next) {
          navigate(next.path);
        }
      }}
    />
  );
});

export default StorefrontNavDropdown;
